import { Dictionary } from "flow/api/types";

export function getProperty(propertyName: string, subTree: Dictionary): any {
    if (subTree[propertyName] !== undefined) {
        return subTree[propertyName];
    }
    return subTree[propertyName.toLowerCase()];
}

export function getString(propertyName: string, subTree: Dictionary, defaultValue: string): string {
    const propValue = getProperty(propertyName, subTree);

    if (propValue !== undefined && typeof propValue === "string") {
        return propValue;
    } else if (propValue !== undefined) {
        throw new Error(this.moduleKeyName + " product property is not a string.  Will not be used until it is fixed.");
    }
    return defaultValue;
}

export function getBool(propertyName: string, subTree: Dictionary, defaultValue: boolean): boolean {
    const propValue = getProperty(propertyName, subTree);

    if (
        propValue !== undefined &&
        (propValue === true || (typeof propValue === "string" && propValue.toLowerCase() === "true"))
    ) {
        return true;
    } else if (propValue === undefined) {
        return defaultValue;
    }
    return false;
}

export function getNumber(propertyName: string, subTree: Dictionary, defaultValue: number): number {
    const propValue = getProperty(propertyName, subTree);

    if (propValue !== undefined) {
        const value = parseInt(propValue, 10);
        if (!isNaN(value)) {
            return value;
        }
    }

    return defaultValue;
}

export function getUrl(propertyName: string, subTree: Dictionary): string {
    let url = getProperty(propertyName, subTree);
    if (url && url[url.length - 1] !== "/") {
        url = url + "/";
    }

    return url;
}
